import React from 'react';
import { useNavigate } from 'react-router-dom';
import './EntityLink.css';

/**
 * A date/time that opens the calendar on that day (date: YYYY-MM-DD).
 */
const DateLink = ({ date, className = '', children, title }) => {
  const navigate = useNavigate();

  if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return <span className={className}>{children}</span>;
  }

  return (
    <button
      type="button"
      className={`entity-link ${className}`.trim()}
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/calendar?date=${date}`);
      }}
      title={title || date}
    >
      {children || date}
    </button>
  );
};

export default DateLink;
